import React from 'react';
import { clsx } from 'clsx';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ size = 'md', className }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return (
    <div className={clsx('relative', className)}>
      <div className={clsx(
        'animate-spin rounded-full border-b-2 border-emerald-500',
        sizeClasses[size]
      )} />
      <span className="sr-only">Loading...</span>
    </div>
  );
};